import { gql } from '@apollo/client';

import { PAGE_INFO_FIELDS, RESUME_FIELDS, VACANCY_FIELDS } from './fields';

export const GET_PROFILE_ADS = gql`
  ${VACANCY_FIELDS}

  ${RESUME_FIELDS}

  query Ads(
    $state: ProfileAdTabStatesEnum!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    profile {
      ... on UserProfile {
        ads(
          state: $state
          after: $after
          before: $before
          first: $first
          last: $last
        ) {
          nodes {
            ... on Resume {
              ...resumeFields
            }
            ... on Vacancy {
              ...vacancyFields
            }
          }
          totalCount
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
      }
    }
  }
`;

export const GET_VACANCIES = gql`
  ${VACANCY_FIELDS}

  ${PAGE_INFO_FIELDS}

  query Vacancies(
    $filter: AdFilter
    $scope: AdScopeEnum
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sortBy: AdSortByEnum
  ) {
    vacancies(
      filter: $filter
      scope: $scope
      after: $after
      before: $before
      first: $first
      last: $last
      sortBy: $sortBy
    ) {
      totalCount
      edges {
        cursor
      }
      nodes {
        ...vacancyFields
      }
      pageInfo {
        ...pageInfoFields
      }
    }
  }
`;

export const GET_RESUMES = gql`
  ${RESUME_FIELDS}
  ${PAGE_INFO_FIELDS}

  query Resumes(
    $filter: AdFilter
    $scope: AdScopeEnum
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sortBy: AdSortByEnum
  ) {
    resumes(
      filter: $filter
      scope: $scope
      after: $after
      before: $before
      first: $first
      last: $last
      sortBy: $sortBy
    ) {
      totalCount
      edges {
        cursor
        node {
          ...resumeFields
        }
      }
      nodes {
        ...resumeFields
      }
      pageInfo {
        ...pageInfoFields
      }
    }
  }
`;

export const GET_EMBED_VACANCIES = gql`
  ${VACANCY_FIELDS}

  query Vacancies(
    $filter: AdFilter
    $scope: AdScopeEnum
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sortBy: AdSortByEnum
  ) {
    vacancies(
      filter: $filter
      scope: $scope
      after: $after
      before: $before
      first: $first
      last: $last
      sortBy: $sortBy
    ) {
      nodes {
        ...vacancyFields
      }
    }
  }
`;
